import { PageRouteBaseConfig } from '@/App/AppRoutes/types';
import { ActionRef } from '@/App/types/actionRef';
import { ScreenRef } from '@/App/types/screenRef';
import { selectRegister } from '@/features/user/register/selectRegister';

export const SignUpRouteBase: PageRouteBaseConfig = {
  key: 'register-page',
  path: '/register/:locale?',
  screenRef: ScreenRef.REGISTER,
  actionRef: ActionRef.REGISTER,
  selector: selectRegister,
};
